module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.ee8914df.2b2e39bf.js"))).then(() => parcelRequire('e5X4q'));